import numeral from "numeral";

numeral.register("locale", "sv", {
  delimiters: {
    thousands: " ",
    decimal: ","
  },
  abbreviations: {
    thousand: "tn", // "tusen" (thousand in Swedish)
    million: "mn", // "miljon" (million in Swedish)
    billion: "md", // "miljard" (billion in Swedish)
    trillion: "bn" // "biljon" (trillion in Swedish)
  },
  ordinal: function (number) {
    return number === 1 ? "a" : "e"; // Swedish ordinal suffix (1:a, 2:a, 3:e, etc.)
  },
  currency: {
    symbol: "kr" // Swedish krona
  }
});

numeral.locale("sv");
